// @core/api/endpoints/platform/remove_platform_member.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/platform';

/**
 * Remove member from platform
 * Removes a member from the platform, revoking all their access and permissions. The member will no longer be able to access any platform resources.
 */
export async function RemovePlatformMember(
  platform_id: string,
  profile_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/members/:profile_id`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
